import React, {useState} from "react";
import { NavLink } from "react-router-dom";
import "./Menu.css";
import dima from "./dima.png";

function Menu() {
    const [showCloseIcon, setShowCloseIcon] =  useState(false);
  const toggleMenu = () => {
    const x = document.getElementById("menu");
    if (x.style.display === "flex") {
      x.style.display = "none";
    } else {
      x.style.display = "flex";
      setShowCloseIcon( pre => !pre);
    }
  };

  const closeMobileMenu = () => {
    const x = document.getElementById("menu");
    if (x.style.display === "flex") {
        x.style.display = "none";
    }
    setShowCloseIcon(false);
  }
  return (
    <div className="container-xxl">
      <nav>
        <ul className="menu-list">
          <li className="home-menu-item">
            <NavLink to={`/`} onClick={() => {closeMobileMenu()}}>
              {" "}
              <img src={dima} width={80} alt="logo" end />{" "}
            </NavLink>
          </li>
          { !showCloseIcon && ( <label for="toggle" onClick={toggleMenu} style={{height: '30px', margin: 0}}>
            ☰
          </label>)}
          { showCloseIcon && (<i className="bi bi-x-lg closeIcon" style={{height: '30px', margin: 0}}  onClick={() => {setShowCloseIcon(false); toggleMenu();}}></i>)}
          <input type="checkbox" id="toggle" />
          <div className="menu-container">
            <li className="menu-item">
              <NavLink to={`/portofolio`}>Portofolio </NavLink>
            </li>
            <li className="menu-item contact">
              <NavLink to={`/contact`}>Contact </NavLink>
            </li>
          </div>
        </ul>
        <div className="menu-mobile" id="menu">
            <NavLink to={`/`} className="menu-item"  onClick={closeMobileMenu}>Home </NavLink>
            <NavLink to={`/portofolio`} className="menu-item"  onClick={() => {closeMobileMenu()}}>Portofolio </NavLink>
            <NavLink to={`/contact`} className="menu-item" onClick={() => {closeMobileMenu()}}>Contact </NavLink>
        </div>
      </nav>
    </div>
  );
}

export default Menu;
